/**
 * This is the same file for all languages except english
 * Why we need these copies is because it's pulling in the dictionary.json in the same folder which is lanugage dependend
 */
import { environment } from 'projects/whocan-app/src/environments/environment';
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable max-len */

import routes from '../../../assets/locale/de/routes.de.dic.json';
import seoDictionary from '../../../assets/locale/de/seo.de.dic.json';



const standardTitle = seoDictionary.app.standardTitle + ' | ' + environment.brandName;
const descriptionPostfix = seoDictionary.app.descriptionPostfix;
const standardDescription = seoDictionary.app.standardDescription + descriptionPostfix;
const seperator = " - ";



export const routesSeo = {
    "404": routes.app[404],
    "404.title": standardTitle + seperator + seoDictionary.app.title[404],
    "404.shortTitle": seoDictionary.app.title[404],

    "about": routes.app.about,
    "about.shortTitle": seoDictionary.app.title.about,
    "about.title": standardTitle + seperator + seoDictionary.app.title.about,
    "about.description": seoDictionary.app.description.about + seperator + standardDescription,

    "feedback": routes.app.feedback,
    "feedback.shortTitle": seoDictionary.app.title.feedback,
    "feedback.title": standardTitle + seperator + seoDictionary.app.title.feedback,
    "feedback.description": seoDictionary.app.description.feedback + seperator + standardDescription,

    "privacy": routes.app.privacy,
    "privacy.title": standardTitle + seperator + seoDictionary.app.title.privacy,
    "privacy.description": seoDictionary.app.description.privacy + seperator + standardDescription,

    "myPolls": routes.app.myPolls,
    "myPolls.title": standardTitle + seperator + seoDictionary.app.title.myPolls,

    "choosePollTemplate": routes.app.choosePollTemplate,

    "createPoll": routes.app.createPoll,
    "createPoll.title": standardTitle + seperator + seoDictionary.app.title.createPoll,
    "createPoll.shortTitle": seoDictionary.app.title.createPoll,

    "editPoll": routes.app.editPoll,
    "editPoll.title": standardTitle + seperator + seoDictionary.app.title.editPoll,
    "editPoll.shortTitle": seoDictionary.app.title.editPoll,

    "pollResponses": routes.app.pollResponses,
    "pollResponses.title": standardTitle + seperator + seoDictionary.app.title.pollResponses,
    "pollResponses.shortTitle": seoDictionary.app.title.pollResponses,

    "pollMatrix": routes.app.pollMatrix,
    "pollMatrix.title": standardTitle + seperator + seoDictionary.app.title.pollMatrix,
    "pollMatrix.shortTitle": seoDictionary.app.title.pollMatrix,

    "vote": routes.app.vote,
    "vote.title": standardTitle + seperator + seoDictionary.app.title.vote,
    "vote.shortTitle": seoDictionary.app.title.vote,

    "votePreview": routes.app.votePreview,
    "votePreview.title": standardTitle + seperator + seoDictionary.app.title.vote,
    "votePreview.shortTitle": seoDictionary.app.title.vote,

    "voteResponse": routes.app.voteResponse,
    "voteResponse.title": standardTitle + seperator + seoDictionary.app.title.voteResponse,
    "voteResponse.shortTitle": seoDictionary.app.title.voteResponse,

    "votePreviewResponse": routes.app.votePreviewResponse,
    "votePreviewResponse.title": standardTitle + seperator + seoDictionary.app.title.voteResponse,
    "votePreviewResponse.shortTitle": seoDictionary.app.title.voteResponse,

    "samplePollsList": routes.app.samplePollsList,
    "samplePollMatrixSuffix": routes.app.samplePollMatrixSuffix,

    "admin": routes.app.admin,
    "testPage": routes.app.testPage,
    "index": routes.app.index,

    "userProfile": routes.app.userProfile,
    "upgradeAnonymous": routes.app.upgradeAnonymous,
    "userLogin": routes.app.userLogin,
    "userSignup": routes.app.userSignup,

};
